import { Image as NativeImage, Platform, View } from "react-native";
import { ImageAssetHandler } from "src/common/libs/utils/image";

const Image = (props) => {
  if (!props.source) {
    return null;
  }
  const size = Platform.OS === "web" ? "@2x" : "";
  const imageSource = props.source?.uri
    ? props.source
    : { uri: ImageAssetHandler.images[`${props.source}${size}`]?.localUri };

  if (!imageSource?.uri) {
    return (
      <View style={[props.style, props.placeholderStyle]}>
        <NativeImage
          {...props}
          source={{
            uri: ImageAssetHandler.images[`${props.placeHolderImage}${size}`]
              ?.localUri,
          }}
          resizeMode="contain"
        />
      </View>
    );
  }
  return <NativeImage {...props} source={imageSource} />;
};

export { Image };
